angular.module("ainapp")
    .controller("VoucherCostCenterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Cost Center Settings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.CostCenters = [];
            MainService.CostCenterList().then(function (response) {
                $scope.CostCenters = response.data;
            });


            $scope.Init = function () {

                $scope.load = false;
                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                })


                $scope.ViewVal = 1;
                $scope.ViewValType = 'Material Request';
                $scope.selectedVoucher = 'Material Request';

                $scope.CostSetting = {
                    VoucherType: "Material Request",
                    Section: "Head",
                    IsVisible: true,
                    IsMandatory: false,
                    CostCenterId: "",
                    DefaultCostCenterId: ""
                }

                $scope.CostCenterSettings = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.CostCenterSettingsbyType("Material Request").then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();

            $scope.getSubList = function () {

                $scope.SubCostCenters = [];
                if (!$scope.CostSetting.Id > 0) {
                    $scope.CostSetting.DefaultCostCenterId = "";
                }


                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CostCenterSubList($scope.CostSetting.CostCenterId).then(function (response) {
                    $scope.SubCostCenters = response.data;
                    var emptyobj = {
                        Id: "",
                        Name: "",
                    }
                    $scope.SubCostCenters.push(emptyobj);
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })


            }


            $scope.switchTab = function (tab, type, voucher) {
                $scope.selectedVoucher = voucher;
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CostCenterSettings = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CostCenterSettingsbyType(type).then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
                $scope.refreshCostCenter();

            }

            $scope.refreshCostCenter = function () {

                $scope.CostSetting = {
                    VoucherType: $scope.ViewValType,
                    Section: "Head",
                    IsVisible: true,
                    IsMandatory: false,
                    CostCenterId: ""
                }

            }

            $scope.editCostCenter = function (data) {

                $scope.CostSetting = data;
                $scope.getSubList();


            }


            $scope.deleteSet = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVoucherCostCenter(data.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.refreshCostCenter();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }


            $scope.saveCostSettings = function () {

                if ($scope.CostSetting.CostCenterId == "") {
                    toastr.warnig("Choose Cost Center");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.CostSetting.VoucherType = $scope.ViewValType;
                    MainService.AddCostCenterSettings($scope.CostSetting).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                            $scope.refreshCostCenter();
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.load = false;
                    })
                }

            }





      }]);
